export const AIR_QUERY_CACHE_KEY = "get_air_saved_cards_infinite_query";
export const AIR_FILTERED_CARDS_QUERY_CACHE_KEY = "get_air_filtered_saved_cards_infinite_query";
